<template>
  <div id="navbar">
    <div
      v-if="isLoggedIn"
      class="navbar row p-0 m-0"
    >
      <div class="col-lg-1 d-none d-sm-block" />
      <div class="col-4 col-md-6 col-lg-6 pl-0">
        <img
          src="@/assets/logo/logo-2.png"
          alt=""
        >
      </div>
      <div class="col-4 col-md-3 col-lg-2 p-0 languange">
        <LanguangeSwitcher />
      </div>
      <div class="col-4 col-md-3 col-lg-2 border-box">
        <Logout />
      </div>
      <div class="col-lg-1 d-none d-sm-block" />
    </div>
    <div
      v-else
      class="navbar row p-0 m-0"
    >
      <div class="col-lg-1 d-none d-sm-block" />
      <div class="col-4 col-md-6 col-lg-7 pl-0">
        <img
          src="@/assets/logo/logo-2.png"
          alt=""
        >
      </div>
      <div class="col-3 col-md-2 col-lg-1" />
      <div class="col-4 col-md-3 col-lg-2 p-0 languange">
        <LanguangeSwitcher />
      </div>
      <div class="col-1 col-md-1 col-lg-1" />
    </div>
  </div>
</template>

<script>
import LanguangeSwitcher from '../components/LanguangeSwitcher2'
import Logout from '@/components/Logout'

export default {
  name: 'Navbar',

  components: {
    LanguangeSwitcher,
    Logout
  },

  props: {
    isLoggedIn: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.navbar{
  background-color: #FFFFFF;
  height: 70px;
}
.languange{
  text-align: center;
}
.profile-icon{
  width: 26px;
  height: 26px;
  object-fit: cover;
}
.profile-icon-2{
  width: 26px;
  height: 26px;
  padding-top: 1px;
  object-fit: cover;
}
.profile-text{
  font-size: 12px;
  font-weight: 600;
  padding-top: 6px;
}
.border-box {
  border-left: 2px solid #DEDEDE;
  cursor: pointer;
}
.dropdown-item {
  font-size: 12px;
}
.dropdown-menu {
  width: 200px !important;
}
.text-email {
  font-size: 8px;
  color: #0091FF;
}
.text-logout {
  font-size: 13px;
  color: #E02020;
}
.border-bottom {
  border-bottom: 2px solid #DEDEDE;
}
</style>
